import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { useGlobalModalContext } from '../GlobalModal';
import styles from './RPAlertsModal.module.scss';

const cx = classNames.bind(styles);

const RPAlertsModal = (): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal width={ModalWidth.Medium} open onClose={closeModal} headerTitle="Risk Products">
      <div className={cx('body')}>
        <div>
          Stay informed with alerts about improvements and deteriorations in credit risk for companies in your
          watchlist, including our proprietary Credit Quality Scores and Fallen Angel Scores.
        </div>
        <ul>
          <li>
            Credit Quality Score (CQS) – CQS is the medium-term assessment that has proven to be an effective leading
            indicator of agency rating actions. It&apos;s measured on a scale of 1-100. A higher score signifies better
            quality.
          </li>
          <li>
            Fallen Angel Score (FAS) - FAS represents the likelihood of an Investment Grade (IG) issuer getting
            downgraded to high yield in the forthcoming 12 months. The ratings can be Very Low, Low, Moderate, High, or
            Very High.
          </li>
          <li>
            CQS Outlook- Near-term (3 month) outlook for the CQS based on its trend, volatility and distance from the
            upgrade/downgrade border. Values can range from Negative, Stable, or Positive.
          </li>
          <li>
            Credit Risk Trend (6M) - This refers to the Credit Risk Estimate (CRE) over the last six months. It can
            range from Strong Deterioration to Moderate Deterioration, Stable, Moderate Improvement, up to Strong
            Improvement.
          </li>
          <li>
            Credit Risk Trend (1Y) - This refers to the Credit Risk Estimate (CRE) over the past year. It can range from
            Strong Deterioration to Moderate Deterioration, Stable, Moderate Improvement, up to Strong Improvement.
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default RPAlertsModal;
